import axios from "axios";

export const axiosClient = axios;
export const create = axios.create;
